module.exports = __webpack_public_path__ + "img/pr-9.e12adf57.png";